<template>
  <ul class="pagination pagination-sm">
    <li
      :class="{ 'disabled': current_page <= 1 }"
      class="page-item">
      <a
        href="#"
        class="page-link"
        @click.prevent="next(current_page-1)">
        &laquo;
      </a>
    </li>
    <li
      v-for="page in totalPages"
      :key="page"
      :class="{ 'active':page === current_page }"
      class="page-item"
    >
      <a
        href="#"
        class="page-link"
        @click.prevent="next(page)"
      >
        {{ page }}
      </a>
    </li>
    <li
      :class="{ 'disabled': current_page === lastPage}"
      class="page-item">
      <a
        href="#"
        class="page-link"
        @click.prevent="next(current_page+1)">
        &raquo;
      </a>
    </li>
  </ul>

</template>
<script>
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

export default {
  props: ['total', 'itensPerPage', 'current_page', 'offset', 'itensPage'],

  computed: {

    totalPages() {
      if (this.lastPage <= 0) {
        return [];
      }
      let from = this.current_page - this.offset;
      if (from < 1) {
        from = 1;
      }
      let to = from + (this.offset * 2);
      if (to >= this.lastPage) {
        to = this.lastPage;
      }
      const arr = [];
      while (from <= to) {
        arr.push(from);
        from += 1;
      }
      return arr;
    },
    firstPage() {
      return 1
    },
    lastPage() {
      return Math.ceil(this.total / this.itensPage)
    }

  },
  methods: {
    next(page) {
      this.$emit('next', page);
    },
  }
};
</script>

<style type="text/css">
.pagination {
    display: -ms-flexbox;
    display: -webkit-box;
    display: flex;
    padding-left: 0;
    list-style: none;
    border-radius: 0.25rem;
    margin-top: 15px;
    margin-left: 35%;
     text-decoration:none;
}
.page-item .page-link {
    border: 2px solid #4576b6;
    border-radius: 4px;
    -webkit-box-sizing: content-box;
    box-sizing: content-box;
    color: #fff;
    line-height: 20px;
    margin: 0 3px;
    -webkit-transition: all .5s;
    transition: all .5s;
    width: 15px;
    text-decoration:none;
}
.page-item.active .page-link {
    border: 2px solid #4576b6;
    border-radius: 4px;
    box-sizing: content-box;
    color: #fff;
    line-height: 20px;
    margin: 0 3px;
    transition: all .5s;
    width: 15px;
    text-decoration:none;
}
.page-link:not(:disabled):not(.disabled) {
    cursor: pointer;
     text-decoration:none;
}
</style>



// WEBPACK FOOTER //
// src/public/pagination/Pagination.vue